import { Component, EventEmitter, Inject, Input, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AISearchResultItem, AQASearchResult } from '../../models';
import { AqaSearchResultCardComponent } from '../aqa-search-result-card/aqa-search-result-card.component';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { AqaViewerComponent } from '../aqa-viewer/aqa-viewer.component';
import { LoadingIndicatorComponent } from '../../../core/components';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-aqa-search-results',
  standalone: true,
  imports: [AqaSearchResultCardComponent, NgbPaginationModule, CommonModule, AqaViewerComponent, LoadingIndicatorComponent],
  templateUrl: './aqa-search-results.component.html',
  styleUrl: './aqa-search-results.component.scss'
})
export class AqaSearchResultsComponent {
  @Input() set resultSet(value: AQASearchResult[]) {
    this.results.set(value);
  }
  @Input() set totCount(value: number) {
    this.totalCount.set(value);
  }
  @Input() set searched(value: boolean) {
    this.hasSearched.set(value);
  }
  @Input() set needPaging(value: boolean) {
    this.showPaging.set(value);
  }
  @Input() set page(value: number) {
    this.currentPage.set(value);
  }
  @Input() set pgSize(value: number) {
    this.pageSize.set(value);
  }
  @Input() set loadingComplete(value: boolean) {
    this.loading.set(value);
  }
  @Input() showSender: boolean = false;
  @Input() maxSize: number = 1;
  @Input() boundaryLinks: boolean = true;

  @Output() pageChange = new EventEmitter<any>();
  //@Output() executeSearch = new EventEmitter();

  private aiSearchBaseUrl: string = '';
  protected documentLoading: boolean = false;

  selectedResult = signal<AQASearchResult | null>(null);
  currentPage = signal<number>(1);
  pageSize = signal<number>(10);
  totalCount = signal<number>(10);
  loading = signal<boolean>(false);
  hasSearched = signal<boolean>(false);
  results = signal<AQASearchResult[]>([]);
  showPaging = signal<boolean>(false);

  constructor(
    @Inject('CONFIG_SETTINGS') private config: any,
    @Inject(OKTA_AUTH) private auth: OktaAuth,
    private http: HttpClient
  ) {
    const configSettings = this.config['general'];
    if (configSettings?.aiSearchApiUrl) {
      const searchUrl = configSettings['aiSearchApiUrl'] as string;
      this.aiSearchBaseUrl = searchUrl.replace(/\/search\/?$/, '');
    }
  }

  get hasResults(): boolean {
    return this.results() && this.results().length > 0;
  }

  get showEmptyState(): boolean {
    return this.hasSearched() && !this.loading() && !this.hasResults;
  }

  get showInitialState(): boolean {
    return !this.hasSearched() && !this.loading();
  }

  get showPager(): boolean {
    return this.totalCount() > this.pageSize() && !this.loading() && this.showPaging();
  }

  // =========================================================================
  // Selection
  // =========================================================================

  onCloseViewer(): void {
    this.selectedResult.set(null);
  }

  onPageChange(page: number): void {
    this.currentPage.set(page);
    this.pageChange.emit(page);
  }

  viewClicked(item: AQASearchResult) {
      this.selectedResult.set(item);
      return;
  }

  trackByResultId(_index: number, result: AQASearchResult): string {
    return result.document.id;
  }

  private buildDocumentUrl(item: AISearchResultItem): string {
    if (!item.documentUrl) {
      return '';
    }
    if (item.documentUrl.startsWith('http://') || item.documentUrl.startsWith('https://')) {
      return item.documentUrl;
    }
    const docUrl = item.documentUrl.startsWith('/') ? item.documentUrl : '/' + item.documentUrl;
    return this.aiSearchBaseUrl + docUrl;
  }

}
